import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import fakeAuth from '../../../auth';
import history from '../../../history';
import AboutModal from '../about/AboutModal';

export default class TopbarProfile extends PureComponent {
  constructor() {
    super();
    this.state = {
      collapse: false,
      openModalInfo: false
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  openModalAbout = () => {
    this.setState(prevState => ({openModalInfo: !prevState.openModalInfo, collapse: false}))
  }

  render() {    
    const { collapse } = this.state;
    const user = JSON.parse(sessionStorage.getItem('usuario'));
    const Ava = `${process.env.REACT_APP_PUBLIC_URL}usuario/ver-foto/${sessionStorage.getItem('token')}`;
    
   return (
      <div className="topbar__profile topbar__btn topbar__btn--new">
        <button type="button" className="topbar__avatar" onClick={this.toggle}>
          {/* <img className="topbar__avatar-img" src={Ava} alt="avatar" /> */}
          <p className="topbar__avatar-name">{user !== null ? user.usuario : ""}</p>
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && <button type="button" className="topbar__back" onClick={this.toggle} />}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            <TopbarMenuLink title="Calendario" icon="calendar-full" path={`${process.env.PUBLIC_URL}/profile/calendar`} onClick={this.toggle} />
            <TopbarMenuLink title="Cambiar Contraseña" icon="cog" path={`${process.env.PUBLIC_URL}/profile/change-pass`} onClick={this.toggle} />
            <div className="topbar__link" onClick={() => {
              fakeAuth.signout(() => {
                sessionStorage.clear();
                //window.location.reload();
                history.push(process.env.PUBLIC_URL +"/log_in");
              });
            }}>
              <span className={`topbar__link-icon lnr lnr-exit`} />
              <p className="topbar__link-title">Cerrar Sessión</p>
            </div>
          </div>
        </Collapse>
        <AboutModal openModal={this.state.openModalInfo} setOpenModal={this.openModalAbout}/>
      </div>
    );
  }
}
